<template>
  <div
    v-if="isVisible"
    class="request-entry d-flex text--black"
  >
    <v-alert
      v-if="inError"
      v-model="isVisible"
      class="mb-0 text-caption"
      dense
      text
      color="red"
      type="error"
    >
      <p class="mb-1">
        There was an error preparing your transfer:
      </p>
      <strong>{{ entry.error }}</strong>
    </v-alert>
    <div
      v-else
      class="grow d-flex flex-column"
    >
      <div
        class="text-caption pb-2"
      >
        {{ entry.description }} .. ({{ entry.progress }} %)
      </div>
      <v-progress-linear
        background-color="purple darken-4"
        background-opacity=".2"
        color="purple darken-4"
        :value="entry.progress"
      />
    </div>
    <div class="shrink pl-3 d-flex align-center">
      <v-btn
        icon
        small
        @click="hide"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EntriesMassAssignmentLine',

  model: {
    prop: 'visible',
    event: 'update',
  },

  props: {
    entry: {
      type: Object,
      required: true,
    },

    visible: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    inError () {
      return !!this.entry?.error
    },

    isVisible: {
      get () { return this.visible },
      set (value) { this.$emit('update', value) },
    },
  },

  methods: {
    hide () {
      this.isVisible = false
    },
  },
}
</script>
